import * as angular from 'angular';

class ArticleEditModalService {
    constructor(
        private $mdDialog
    ) {
        'ngInject';
    }

    show(event, article) {

        let parent = angular.element(document.getElementsByClassName('mw-flexi-modal')[0]);
        return this.$mdDialog.show({
            template: `
                <md-dialog class="mw-mini-modal mw-mini-modal--wide article-edit-dialog-auto-height" aria-label="" layout="column">
                    <mw-article-edit-modal class="mw-mini-modal-wrapper" article="$ctrl.article" layout="column" flex></mw-article-edit-modal>
                </md-dialog>
            `,
            controller: ()=>{},
            locals: {
                article: article
            },
            bindToController: true,
            controllerAs: '$ctrl',
            targetEvent: event,
            parent: parent,
            multiple: true,
            autoWrap: false
        })
    }
}

export default ArticleEditModalService;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/articles/article-edit-modal/article-edit-modal.service.ts
 **/